<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-11 09:43:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-05-12 11:24:27
-->
<template>
  <van-icon :name="direction" :size="width" :color="color" />

  <!-- <div :class="['arrow', direction]" ref="arrowRef"></div> -->
</template>

<script>
export default {
  name: "GArrow",
  props: {
    width: {
      type: [Number],
      default: 22,
    },
    color: {
      type: String,
      default: "#d7d7d7",
    },
    direction: {
      type: String,
      default: "arrow",
    },
  },
  data() {
    return {};
  },
  created() {
    // this.init();
  },
  mounted() {},
  methods: {
    // init() {
    //   this.$nextTick(() => {
    //     let ele = this.$refs.arrowRef;
    //     ele.style.width = this.width + "px";
    //     ele.style.height = this.width + "px";
    //     if (this.color) {
    //       ele.style.borderTop = `2px solid ${this.color}`;
    //       ele.style.borderRight = `2px solid ${this.color}`;
    //     }
    //   });
    // },
  },
};
</script>
<style scoped lang="scss"></style>
